import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { statsApi } from '../api/api';

const StatCard = ({ icon, label, value, color, to, hint, loading }) => (
  <Link
    to={to}
    className="bg-white rounded-2xl p-5 border border-gray-100 transition-all duration-300 block group hover:border-orange-200"
  >
    <div className="flex items-start justify-between mb-3">
      <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: `${color}18` }}>
        <i className={`${icon} text-lg`} style={{ color }}></i>
      </div>
      <i className="fas fa-arrow-right text-gray-200 group-hover:text-orange-400 text-xs transition-colors"></i>
    </div>
    <div className="text-3xl font-bold text-gray-800 mb-0.5">
      {loading ? (
        <span className="inline-block w-10 h-7 bg-gray-100 rounded animate-pulse"></span>
      ) : (
        (value ?? 0)
      )}
    </div>
    <div className="text-sm text-gray-600 font-semibold">{label}</div>
    {hint && <div className="text-xs text-gray-400 mt-1">{hint}</div>}
  </Link>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError('');

    const load = async () => {
      try {
        const sRes = await statsApi.get();
        if (!alive) return;
        if (sRes?.success) {
          setStats(sRes.data || {});
        } else {
          setError(sRes?.message || 'Failed to load stats');
        }
      } catch (err) {
        if (alive) setError(err.message || 'Could not load dashboard data');
      } finally {
        if (alive) setLoading(false);
      }
    };

    load();
    const t = setTimeout(() => { if (alive) setLoading(false); }, 8000);
    return () => { alive = false; clearTimeout(t); };
  }, []);

  return (
    <div className="max-w-7xl mx-auto">
      {error && (
        <div className="mb-6 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm">
          <i className="fas fa-exclamation-circle mr-2"></i>{error}
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <StatCard loading={loading} icon="fas fa-calendar-alt" label="Events" value={stats?.events} color="#f97316" to="/admin/events" hint="Manage kathas & events" />
        <StatCard loading={loading} icon="fas fa-images" label="Gallery" value={stats?.gallery} color="#8b5cf6" to="/admin/gallery" hint="Photos & videos" />
        <StatCard loading={loading} icon="fas fa-video" label="Katha Videos" value={stats?.katha} color="#3b82f6" to="/admin/katha" hint="YouTube links" />
      </div>
    </div>
  );
};

export default AdminDashboard;
